import React, { useState, useEffect } from "react";
import Octicon from "react-octicon";

export function GlobalToggleButton({ variant = "light text-muted", className = "", iconOnly = false }) {
  const [isExpanded, setIsExpanded] = useState(() => {
    return localStorage.getItem("globalTreeExpanded") === "true";
  });

  // Listen for expand/collapse events from other button instances
  useEffect(() => {
    const handleExpandAllEvent = (event) => {
      if (event.detail?.isGlobal) {
        setIsExpanded(event.detail.expanded);
      }
    };

    window.addEventListener("expandAll", handleExpandAllEvent);

    return () => {
      window.removeEventListener("expandAll", handleExpandAllEvent);
    };
  }, []);

  const handleToggle = () => {
    const newState = !isExpanded;

    // Set global state
    localStorage.setItem("globalTreeExpanded", newState.toString());

    // Update local state
    setIsExpanded(newState);

    // Dispatch event - let each component handle its own localStorage
    // (components have different semantics: some use 'collapsed', others use 'expanded')
    window.dispatchEvent(
      new CustomEvent("expandAll", {
        detail: {
          timestamp: Date.now(),
          expanded: newState,
          isGlobal: true,
        },
      })
    );
  };

  // Icon-only version for subtle contexts like table headers
  if (iconOnly) {
    return (
      <button
        className={`btn btn-sm d-flex align-items-center justify-content-center ${className}`}
        onClick={handleToggle}
        title={isExpanded ? "Collapse all items" : "Expand all items"}
        aria-label={isExpanded ? "Collapse all tree items" : "Expand all tree items"}
      >
        <Octicon name={isExpanded ? "fold" : "unfold"} />
      </button>
    );
  }

  // Full button version for main contexts like sidebar
  return (
    <button
      className={`btn btn-sm btn-${variant} d-flex align-items-center ${className}`}
      onClick={handleToggle}
      title={isExpanded ? "Collapse all tree items globally" : "Expand all tree items globally"}
    >
      <Octicon name={isExpanded ? "fold" : "unfold"} />
      {isExpanded ? "Collapse All" : "Expand All"}
    </button>
  );
}
